import { Component, OnInit } from '@angular/core';
import { Liste } from 'model/model.liste';
import { Addrembrs } from 'model/model.addrembrs';
import { AdminService } from '../../services/admin';


@Component({
  selector: 'app-remboursement',
  templateUrl: './remboursement.component.html',
  styleUrls: ['./remboursement.component.scss']
})
export class RemboursementComponent implements OnInit {

  remboursement: Liste = new Liste();
  mode: number = 1;
  mode_SLC: number = 1;
  mode_SRT: number = 1;
  mode_161: number = 1;
  mode_montant: number;
  ato: any;
  pageListe: any;
  pageRembourse: any;
  listeRejet: any;
  pageEnregistrer: any;
  listeJuridique: any;
  listeAdmin: any;
  listeMed: any;
  listeChef: any;
  listePre: any;
  listeGeneral: any;
  listeIrrecevable: any;
  pageEngager:Array<Addrembrs>=new Array<Addrembrs>();
  pageDRH:any;
  pageOrdonnancer:Array<Addrembrs>=new Array<Addrembrs>();
  motCle: String = "";
  motCleEngager: String = "";
    motCleJuridique: String = "";
    motCleAdmin: String = "";
    motCleMed: String = "";
    motCleChef: String = "";
    motClePre: String = "";
    motCleGeneral: String = "";
    motCleIrrecevable: String = "";
    motCleRejet: String = "";
  currentPage: number = 1;
  currentPageJuridique: number = 1;
  currentPageAdmin: number = 1;
  currentPageMed: number = 1;
  currentPageChef: number = 1;
  currentPagePre: number = 1;
  currentPageGeneral: number = 1;
  currentPageIrrecevable: number = 1;
  currentPageRejet: number = 1;
  size: number = 10;
  im:any=312046;
  code:String="ABCDEFghojklm123456789";

  pages: Array<number>;
  pagesJuridique: Array<number>;
  pagesAdmin: Array<number>;
  pagesMed: Array<number>;
   pagesChef: Array<number>;
   pagesPre: Array<number>;
   pagesGeneral: Array<number>;
   pagesIrrecevable: Array<number>;
   pagesRejet: Array<number>;
  id_agent_actuel: any;
  loginuserCMSActuel: any;


  constructor(public adminService: AdminService) {
    this.id_agent_actuel = this.adminService.getUserIMIscrit();
    this.loginuserCMSActuel = this.adminService.getLoginUseCMS();
    if(this.loginuserCMSActuel=="cms_daf"){
       this.mode_montant=1;
     }else{
       this.mode_montant=11;
     }
   }

  ngOnInit() {
   
      this.doSearchGeneral();
   
    
  }



  doSearchGeneral(){
    this.adminService.getListRembourseGeneral(this.motCleGeneral,this.currentPageGeneral,this.size)
    .subscribe(data =>{
      this.listeGeneral= data;
      //this.pages = new Array(data.totalPages);
      if(data && data[0].infoEnregistrement.totalPages)
            this.pagesGeneral = new Array(data[0].infoEnregistrement.totalPages);       
          else this.pagesGeneral=new Array(0);
    },err =>{
      console.log(err);
    })
  }

  chercherGeneral() {
    if(this.motCleGeneral == this.id_agent_actuel || this.loginuserCMSActuel == "cms_daf"){
      this.doSearchGeneral();
      this.mode_montant=1;
    }else{
      this.doSearchGeneral();
      this.mode_montant=11;
    }
   
  } 


  recupererLibelleEtat(code){
    return this.adminService.getLibelleEtatDossier(code);
  }

  gotoPageGeneral(i: number) {
    this.currentPageGeneral = i;
    this.doSearchGeneral();

  }

}
